import React from "react";
import {Navigate} from "react-router-dom";
import {GlobalState} from "../../global/GlobalState";
import {Configuration} from "../../global/Configuration";

export function LogoutPage() {
	if (GlobalState.userSession == null) {
		return <Navigate to={"/"}/>;
	} else {
		logout();
		return <></>;
	}
}

export function logout() {
	GlobalState.userSession = null;
	window.location.assign(Configuration.cognitoLogoutUrl);
}
